// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2020-01-01 14:53:34 +0100 (Wed, 01 Jan 2020) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 106758 $
//  Purpose   : jobs package
// =============================================================================
export const parts = true
export const templates = true

export {sagas} from './sagas'

import * as reducers from './reducers'
export {reducers}

import * as actions from './actions'
export {actions}

import * as views from './views'
export {views}
